/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Color_FormattingInputs */



/**
* | output |
* | --- |
* | "Remove color formatting" |
*
* @param {Remove_Color_FormattingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_color_formatting = /** @type {((inputs?: Remove_Color_FormattingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Color_FormattingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la mise en forme des couleurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Farbformatierung entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi formattazione del colore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить цветовое форматирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar formato de color")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除颜色格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("色の書式を削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रंग फ़ॉर्मेटिंग हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover formatação de cor")
	return /** @type {LocalizedString} */ ("Remove color formatting")
});